import { HttpContextToken } from '@angular/common/http';

export type HttpErrorFeedbackPolicy = 'global-toast' | 'feature-owned' | 'silent' | 'session-only';

export const HTTP_ERROR_FEEDBACK_POLICY = new HttpContextToken<HttpErrorFeedbackPolicy>(() => 'global-toast');

